export default __webpack_public_path__ + "static/media/NoRacesMascot.b058bd4e.jpg";